/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Fill_In_DetailsInputs */

const en_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const de_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const fr_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const es_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const it_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const nl_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const pl_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const fi_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const da_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

const sv_negotiation_fill_in_details = /** @type {(inputs: Negotiation_Fill_In_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in your details`)
};

/**
* | output |
* | --- |
* | "Fill in your details" |
*
* @param {Negotiation_Fill_In_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_fill_in_details = /** @type {((inputs?: Negotiation_Fill_In_DetailsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Fill_In_DetailsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_fill_in_details(inputs)
	if (locale === "fr") return fr_negotiation_fill_in_details(inputs)
	if (locale === "es") return es_negotiation_fill_in_details(inputs)
	if (locale === "it") return it_negotiation_fill_in_details(inputs)
	if (locale === "nl") return nl_negotiation_fill_in_details(inputs)
	if (locale === "pl") return pl_negotiation_fill_in_details(inputs)
	if (locale === "fi") return fi_negotiation_fill_in_details(inputs)
	if (locale === "da") return da_negotiation_fill_in_details(inputs)
	if (locale === "sv") return sv_negotiation_fill_in_details(inputs)
	return en_negotiation_fill_in_details(inputs)
});